import type { Color } from "@mui/material";
import { Avatar } from "@mui/material";
import { blue, deepPurple, grey } from "@mui/material/colors";
import { makeModeAwareAccentSurface } from "@entrilia/shared/utilities/colorHelper";
import type { InvestorCommunicationType } from "../../../api/types/investorCommunicationsTypes";
import { investorCommunicationTypeIcons } from "./investorCommunicationTypeIcons";

interface Props {
  type: InvestorCommunicationType;
  size?: number;
}

const typeColors: Record<InvestorCommunicationType, Color> = {
  Article: blue,
  Video: deepPurple,
};

const InvestorCommunicationTypeAvatar = ({ type, size = 32 }: Props) => {
  const Icon = investorCommunicationTypeIcons[type];

  return (
    <Avatar
      variant="rounded"
      sx={(t) => ({ ...makeModeAwareAccentSurface(t, typeColors[type] || grey), width: size, height: size })}
    >
      <Icon />
    </Avatar>
  );
};

export default InvestorCommunicationTypeAvatar;
